export const CATEGORIES = [
  "Food & Dining",
  "Transport",
  "Shopping",
  "Entertainment",
  "Healthcare",
  "Utilities",
  "Salary",
  "Freelance",
  "Investment",
  "Rent",
];

export const CATEGORY_COLORS = {
  "Food & Dining": "#00E5FF",
  Transport: "#7C3AED",
  Shopping: "#F5A623",
  Entertainment: "#FF4D6D",
  Healthcare: "#00D4AA",
  Utilities: "#6366F1",
  Salary: "#22C55E",
  Freelance: "#A78BFA",
  Investment: "#34D399",
  Rent: "#FB923C",
};

const rand = (min, max) => Math.floor(Math.random() * (max - min + 1)) + min;
const fmt = (d) => d.toISOString().split("T")[0];

const baseTransactions = [
  { id: 1, date: "2024-01-05", description: "Monthly Salary", amount: 5200, category: "Salary", type: "income" },
  { id: 2, date: "2024-01-06", description: "Netflix Subscription", amount: 15.99, category: "Entertainment", type: "expense" },
  { id: 3, date: "2024-01-08", description: "Grocery Store", amount: 87.5, category: "Food & Dining", type: "expense" },
  { id: 4, date: "2024-01-10", description: "Freelance Project", amount: 1200, category: "Freelance", type: "income" },
  { id: 5, date: "2024-01-12", description: "Uber Ride", amount: 24.3, category: "Transport", type: "expense" },
  { id: 6, date: "2024-01-15", description: "Electricity Bill", amount: 110, category: "Utilities", type: "expense" },
  { id: 7, date: "2024-01-18", description: "Amazon Shopping", amount: 156.75, category: "Shopping", type: "expense" },
  { id: 8, date: "2024-01-20", description: "Doctor Visit", amount: 80, category: "Healthcare", type: "expense" },
  { id: 9, date: "2024-01-22", description: "Restaurant Dinner", amount: 63, category: "Food & Dining", type: "expense" },
  { id: 10, date: "2024-01-25", description: "Stock Dividend", amount: 340, category: "Investment", type: "income" },
  { id: 11, date: "2024-01-28", description: "Monthly Rent", amount: 1400, category: "Rent", type: "expense" },
  { id: 12, date: "2024-01-30", description: "Spotify", amount: 9.99, category: "Entertainment", type: "expense" },
  { id: 13, date: "2024-02-01", description: "Monthly Salary", amount: 5200, category: "Salary", type: "income" },
  { id: 14, date: "2024-02-03", description: "Coffee Shop", amount: 32.5, category: "Food & Dining", type: "expense" },
  { id: 15, date: "2024-02-07", description: "Metro Pass", amount: 45, category: "Transport", type: "expense" },
  { id: 16, date: "2024-02-09", description: "Freelance Design", amount: 800, category: "Freelance", type: "income" },
  { id: 17, date: "2024-02-12", description: "Internet Bill", amount: 59.99, category: "Utilities", type: "expense" },
  { id: 18, date: "2024-02-14", description: "Valentine Dinner", amount: 120, category: "Food & Dining", type: "expense" },
  { id: 19, date: "2024-02-18", description: "Clothing Store", amount: 215, category: "Shopping", type: "expense" },
  { id: 20, date: "2024-02-20", description: "Gym Membership", amount: 40, category: "Healthcare", type: "expense" },
  { id: 21, date: "2024-02-23", description: "Monthly Rent", amount: 1400, category: "Rent", type: "expense" },
  { id: 22, date: "2024-02-25", description: "Investment Return", amount: 520, category: "Investment", type: "income" },
  { id: 23, date: "2024-02-27", description: "Streaming Bundle", amount: 22, category: "Entertainment", type: "expense" },
  { id: 24, date: "2024-03-01", description: "Monthly Salary", amount: 5200, category: "Salary", type: "income" },
  { id: 25, date: "2024-03-04", description: "Grocery Run", amount: 94.2, category: "Food & Dining", type: "expense" },
  { id: 26, date: "2024-03-06", description: "Gas Station", amount: 55, category: "Transport", type: "expense" },
  { id: 27, date: "2024-03-09", description: "Freelance Dev", amount: 1500, category: "Freelance", type: "income" },
  { id: 28, date: "2024-03-13", description: "Water Bill", amount: 35, category: "Utilities", type: "expense" },
  { id: 29, date: "2024-03-16", description: "Electronics", amount: 389, category: "Shopping", type: "expense" },
  { id: 30, date: "2024-03-19", description: "Pharmacy", amount: 28.5, category: "Healthcare", type: "expense" },
  { id: 31, date: "2024-03-22", description: "Concert Ticket", amount: 75, category: "Entertainment", type: "expense" },
  { id: 32, date: "2024-03-24", description: "Monthly Rent", amount: 1400, category: "Rent", type: "expense" },
  { id: 33, date: "2024-03-27", description: "Stock Gains", amount: 680, category: "Investment", type: "income" },
  { id: 34, date: "2024-03-29", description: "Sushi Restaurant", amount: 88, category: "Food & Dining", type: "expense" },
  { id: 35, date: "2024-04-01", description: "Monthly Salary", amount: 5500, category: "Salary", type: "income" },
  { id: 36, date: "2024-04-03", description: "Taxi", amount: 31, category: "Transport", type: "expense" },
  { id: 37, date: "2024-04-07", description: "Groceries", amount: 102, category: "Food & Dining", type: "expense" },
  { id: 38, date: "2024-04-10", description: "Phone Bill", amount: 65, category: "Utilities", type: "expense" },
  { id: 39, date: "2024-04-13", description: "Online Course", amount: 199, category: "Shopping", type: "expense" },
  { id: 40, date: "2024-04-16", description: "Freelance Consult", amount: 950, category: "Freelance", type: "income" },
  { id: 41, date: "2024-04-19", description: "Movie Theater", amount: 36, category: "Entertainment", type: "expense" },
  { id: 42, date: "2024-04-22", description: "Monthly Rent", amount: 1400, category: "Rent", type: "expense" },
  { id: 43, date: "2024-04-25", description: "Dental Check", amount: 150, category: "Healthcare", type: "expense" },
  { id: 44, date: "2024-04-28", description: "Dividend Income", amount: 290, category: "Investment", type: "income" },
  { id: 45, date: "2024-05-01", description: "Monthly Salary", amount: 5500, category: "Salary", type: "income" },
  { id: 46, date: "2024-05-04", description: "Burger Joint", amount: 22, category: "Food & Dining", type: "expense" },
  { id: 47, date: "2024-05-07", description: "Train Ticket", amount: 42, category: "Transport", type: "expense" },
  { id: 48, date: "2024-05-10", description: "Freelance Writing", amount: 600, category: "Freelance", type: "income" },
  { id: 49, date: "2024-05-13", description: "Gas Bill", amount: 48, category: "Utilities", type: "expense" },
  { id: 50, date: "2024-05-16", description: "Shoe Shopping", amount: 175, category: "Shopping", type: "expense" },
  { id: 51, date: "2024-05-19", description: "Vitamins", amount: 35, category: "Healthcare", type: "expense" },
  { id: 52, date: "2024-05-22", description: "Monthly Rent", amount: 1400, category: "Rent", type: "expense" },
  { id: 53, date: "2024-05-25", description: "Stock Portfolio", amount: 810, category: "Investment", type: "income" },
  { id: 54, date: "2024-05-28", description: "Gaming Subscription", amount: 14.99, category: "Entertainment", type: "expense" },
  { id: 55, date: "2024-06-01", description: "Monthly Salary", amount: 5500, category: "Salary", type: "income" },
  { id: 56, date: "2024-06-05", description: "Pizza Night", amount: 45, category: "Food & Dining", type: "expense" },
  { id: 57, date: "2024-06-08", description: "Car Rental", amount: 120, category: "Transport", type: "expense" },
  { id: 58, date: "2024-06-11", description: "Freelance App Dev", amount: 2200, category: "Freelance", type: "income" },
  { id: 59, date: "2024-06-15", description: "Electric Bill", amount: 95, category: "Utilities", type: "expense" },
  { id: 60, date: "2024-06-18", description: "Home Decor", amount: 280, category: "Shopping", type: "expense" },
  { id: 61, date: "2024-06-21", description: "Eye Check", amount: 90, category: "Healthcare", type: "expense" },
  { id: 62, date: "2024-06-24", description: "Monthly Rent", amount: 1400, category: "Rent", type: "expense" },
  { id: 63, date: "2024-06-27", description: "ETF Returns", amount: 450, category: "Investment", type: "income" },
  { id: 64, date: "2024-06-29", description: "Live Concert", amount: 95, category: "Entertainment", type: "expense" },
];

export const mockTransactions = baseTransactions.map((t, i) => ({ ...t, id: i + 1 }));

export const getMonthlyData = () => {
  const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun"];
  return months.map((month, idx) => {
    const monthNum = idx + 1;
    const txns = mockTransactions.filter((t) => {
      const m = parseInt(t.date.split("-")[1]);
      return m === monthNum;
    });
    const income = txns.filter((t) => t.type === "income").reduce((s, t) => s + t.amount, 0);
    const expenses = txns.filter((t) => t.type === "expense").reduce((s, t) => s + t.amount, 0);
    return { month, income: Math.round(income), expenses: Math.round(expenses), balance: Math.round(income - expenses) };
  });
};

export const getCategorySpending = () => {
  const expense = mockTransactions.filter((t) => t.type === "expense");
  const map = {};
  expense.forEach((t) => {
    map[t.category] = (map[t.category] || 0) + t.amount;
  });
  return Object.entries(map)
    .map(([name, value]) => ({ name, value: Math.round(value), color: CATEGORY_COLORS[name] || "#888" }))
    .sort((a, b) => b.value - a.value);
};
